module.exports = __webpack_public_path__ + "static/media/KUB.6a67d6ef.png";